/**
 * @owner @Appboy/push
 */

// generated from 794_298 samples

import { z } from "zod";
import { common } from "../common";
import { messageGetBaseSchema } from "./messageGetBaseSchema";
import { clickActionSchema } from "@schemas/shared/clickActionSchema";

export const androidPushMessageGetSchema = z.object({
  ...messageGetBaseSchema.shape,
  message_type: z.literal("androidPush"),
  variation_id: common.objectId,
  // undefined: 23_739 (2.99%), defined 770_559 (97.01%)
  // null: 757_985 (98.37%)
  android_accent_color: z.string().length(10).nullable().optional(),
  // undefined: 23_739 (2.99%), defined 770_559 (97.01%)
  android_carousel_slides: z
    .array(
      z.object({
        action_type: clickActionSchema,
        // null: 81 (1.87%)
        hosted_image_url: z.string().nullable(),
        human_readable: z.string(),
        id: common.objectId,
        // true 610 (14.11%), false 3_712 (85.89%)
        is_custom_image_url: z.boolean(),
        // null: 1_199 (27.74%)
        link: z.string().nullable(),
        // null: 2_920 (67.56%)
        marked_as_deleted: z.boolean().nullable(),
        // null: 1_375 (31.81%)
        subtitle: z.string().nullable(),
        // null: 36 (0.83%)
        subtitle_justification: z
          .enum([
            "center", // 3_132 (73.08%)
            "start", // 1_144 (26.69%)
            "end", // 10 (0.23%)
          ])
          .nullable(),
        // null: 618 (14.30%)
        title: z.string().nullable(),
        // null: 36 (0.83%)
        title_justification: z
          .enum([
            "center", // 3_132 (73.08%)
            "start", // 1_144 (26.69%)
            "end", // 10 (0.23%)
          ])
          .nullable(),
        // null: 4_036 (93.38%)
        // true 233 (81.47%), false 53 (18.53%)
        use_webview: z.boolean().nullable().optional(),
      })
    )
    .optional(),
  // undefined: 23_739 (2.99%), defined 770_559 (97.01%)
  // null: 753_802 (97.83%)
  android_carousel_type: common
    .numericEnum([
      2, // 15_832 (94.48%)
      1, // 925 (5.52%)
    ])
    .nullable()
    .optional(),
  // undefined: 23_739 (2.99%), defined 770_559 (97.01%)
  // null: 764_435 (99.21%)
  android_category: z
    .enum([
      "promo", // 2_658 (43.40%)
      "msg", // 1_453 (23.73%)
      "recommendation", // 554 (9.05%)
      "event", // 534 (8.72%)
      "alarm", // 455 (7.43%)
      "reminder", // 361 (5.89%)
      "err", // 25 (0.41%)
      "social", // 24 (0.39%)
      "service", // 22 (0.36%)
      "status", // 14 (0.23%)
      "call", // 13 (0.21%)
      "progress", // 7 (0.11%)
      "email", // 3 (0.05%)
      "sys", // 1 (0.02%)
      "transport",
    ])
    .nullable()
    .optional(),
  // undefined: 23_739 (2.99%), defined 770_559 (97.01%)
  android_collapse_key: z.string().nullable().optional(),
  // undefined: 23_739 (2.99%), defined 770_559 (97.01%)
  // null: 220_187 (28.57%)
  android_custom_uri: z.string().nullable().optional(),
  // undefined: 23_739 (2.99%), defined 770_559 (97.01%)
  // null: 706_711 (91.71%)
  android_extras: z.record(z.string(), z.string()).nullable().optional(),
  // undefined: 23_739 (2.99%), defined 770_559 (97.01%)
  // null: 10_210 (1.33%)
  android_fcm_priority: z
    .enum([
      "normal", // 751_609 (98.85%)
      "high", // 8_740 (1.15%)
    ])
    .nullable()
    .optional(),
  // undefined: 23_739 (2.99%), defined 770_559 (97.01%)
  // null: 769_776 (99.90%)
  // format integer: 666 (85.06%)
  android_notification_id: z.string().nullable().optional(),
  // undefined: 23_739 (2.99%), defined 770_559 (97.01%)
  // true 185_895 (24.12%), false 584_664 (75.88%)
  android_only_most_recent_device: z.boolean().nullable().optional(),
  // undefined: 23_739 (2.99%), defined 770_559 (97.01%)
  // null: 128 (0.02%)
  // avg: 0.01, min: -2, max: 2
  android_priority: z.int().nullable().optional(),
  // undefined: 23_739 (2.99%), defined 770_559 (97.01%)
  android_push_buttons: z
    .array(
      z.object({
        // null: 2 (0.01%)
        action_type: clickActionSchema,
        human_readable: z.string(),
        id: common.objectId,
        // true 637 (3.26%), false 18_883 (96.74%)
        marked_as_deleted: z.boolean(),
        // null: 20 (0.10%)
        text: z.string().nullable(),
        // null: 3_207 (16.43%)
        uri: z.string().nullable(),
        // true 17_781 (91.09%), false 1_739 (8.91%)
        use_webview: z.boolean().nullable().optional(),
      })
    )
    .optional(),
  // undefined: 23_739 (2.99%), defined 770_559 (97.01%)
  // null: 677_856 (87.97%)
  android_push_icon_image_url: z.string().nullable().optional(),
  // undefined: 23_739 (2.99%), defined 770_559 (97.01%)
  // null: 32 (0.00%)
  android_push_message: z.string().nullable().optional(),
  // undefined: 23_739 (2.99%), defined 770_559 (97.01%)
  // null: 760_945 (98.75%)
  android_sound: z.string().nullable().optional(),
  // undefined: 23_739 (2.99%), defined 770_559 (97.01%)
  // null: 760_675 (98.72%)
  android_summary_text: z.string().nullable().optional(),
  // undefined: 23_739 (2.99%), defined 770_559 (97.01%)
  // null: 4_086 (0.53%)
  // avg: 2071892.92, min: -259200, max: 2592000
  android_time_to_live: z.int().nullable().optional(),
  // undefined: 23_739 (2.99%), defined 770_559 (97.01%)
  // null: 45 (0.01%)
  android_title: z.string().nullable().optional(),
  // undefined: 23_739 (2.99%), defined 770_559 (97.01%)
  android_title_big: z.string().nullable().optional(),
  // undefined: 23_739 (2.99%), defined 770_559 (97.01%)
  // null: 94 (0.01%)
  android_uri_type: clickActionSchema.nullable().optional(),
  // undefined: 23_739 (2.99%), defined 770_559 (97.01%)
  // null: 1_508 (0.20%)
  // true 725_382 (94.32%), false 43_669 (5.68%)
  android_use_webview: z.boolean().nullable().optional(),
  // undefined: 23_739 (2.99%), defined 770_559 (97.01%)
  // null: 763_002 (99.02%)
  // avg: 0.88, min: -1, max: 1
  android_visibility: z.int().nullable().optional(),
  // undefined: 23_739 (2.99%), defined 770_559 (97.01%)
  // null: 679_712 (88.21%)
  image_url: z.string().nullable().optional(),
  // undefined: 23_739 (2.99%), defined 770_559 (97.01%)
  // true 29_131 (3.78%), false 741_428 (96.22%)
  is_custom_image_url: z.boolean().nullable().optional(),
  // undefined: 23_739 (2.99%), defined 770_559 (97.01%)
  // true 21_732 (2.82%), false 748_827 (97.18%)
  is_custom_push_icon_image_url: z.boolean().nullable().optional(),
  // undefined: 23_739 (2.99%), defined 770_559 (97.01%)
  // true 2_528 (0.33%), false 768_031 (99.67%)
  is_notification_channel_dynamic: z.boolean().nullable().optional(),
  // avg: 291587771.63, min: 0, max: 1749555601
  last_sent_android_push: z.int().min(0),
  // null: 7 (0.00%)
  link_template_ids: z.array(z.string()).nullable(),
  // undefined: 23_739 (2.99%), defined 770_559 (97.01%)
  // null: 329_905 (42.81%)
  // format object-id: 438_138 (99.43%)
  notification_channel_id: z.string().nullable().optional(),
});
